import { buildRoutes } from "@app/routes/RouteBuilder";
import lazyWithRetry from "@shared/utils/lazyWithRetry";

const DarphaIA = lazyWithRetry(() => import("./Darpha_IA"), "DarphaIA");

/**
 * Rutas del agente de IA
 * Disponible para Admin, Inspector, Supervisor, Developer, General y RRHH.
 */
const aiAgentRoutes = buildRoutes([
  {
    path: "/ai-agent",
    element: DarphaIA,
    roles: [1, 2, 3, 5, 6, 7],
  },
]);

export default aiAgentRoutes;
